import { useAppNavigation } from '@euler/app/components/AppNavigationProvider';
import { FeatureNotEnabledView } from '@euler/components/entitlements/FeatureNotEnabledView';
import { useStoreFeature } from '@euler/functions/entitlements/useStoreFeature';
import { useUserProfileInfo } from '@euler/functions/user/useUserProfileInfo';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { StoreFeature } from '@euler/model/enum';
import { BiExportListView } from './exports/BiExportListView';

export type BiExportListPageParams = Record<string, never>;

/** 导出记录: the member's dashboard PDF exports in this store. */
export const BiExportListPage = wrapNavigatorScreen(
  () => {
    const navigation = useAppNavigation();
    const profile = useUserProfileInfo();
    const bi = useStoreFeature(StoreFeature.Bi);
    if (!bi.enabled) return <FeatureNotEnabledView feature={StoreFeature.Bi} />;
    return (
      <BiExportListView
        key={profile ? `${profile.org.id}:${profile.store.id}` : 'none'}
        onBack={() => navigation.goBack()}
      />
    );
  },
  () => ({
    title: '导出记录',
    headerShown: false,
    headerMode: 'float',
  }),
);
